import { render } from "./SearchNotFound.vue?vue&type=template&id=707e9dff"
import script from "./SearchNotFound.vue?vue&type=script&lang=js"
export * from "./SearchNotFound.vue?vue&type=script&lang=js"

import "./SearchNotFound.vue?vue&type=style&index=0&id=707e9dff&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__